import React from 'react';
import { ArrowsClockwise, FileCsv, FilePdf } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

/**
 * Top-of-page controls: time-range, granularity, comparison-period, refresh,
 * and the two export buttons (CSV/PDF).
 */
const TrendsToolbar = ({
  days, setDays,
  granularity, setGranularity,
  compareTo, setCompareTo,
  loading, exporting,
  onRefresh, onExportCsv, onExportPdf,
}) => (
  <div className="flex flex-wrap items-center gap-3">
    <Select value={days} onValueChange={setDays}>
      <SelectTrigger className="w-32"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="7">Last 7 days</SelectItem>
        <SelectItem value="30">Last 30 days</SelectItem>
        <SelectItem value="90">Last 90 days</SelectItem>
        <SelectItem value="180">Last 6 months</SelectItem>
        <SelectItem value="365">Last year</SelectItem>
      </SelectContent>
    </Select>
    <Select value={granularity} onValueChange={setGranularity}>
      <SelectTrigger className="w-28"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="daily">Daily</SelectItem>
        <SelectItem value="weekly">Weekly</SelectItem>
        <SelectItem value="monthly">Monthly</SelectItem>
      </SelectContent>
    </Select>
    <Select value={compareTo} onValueChange={setCompareTo}>
      <SelectTrigger className="w-40"><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="previous_week">vs Last Week</SelectItem>
        <SelectItem value="previous_month">vs Last Month</SelectItem>
        <SelectItem value="previous_year">vs Last Year</SelectItem>
      </SelectContent>
    </Select>
    <Button variant="outline" size="sm" onClick={onRefresh} disabled={loading}>
      <ArrowsClockwise size={16} className={loading ? 'animate-spin' : ''} />
    </Button>
    <div className="flex-1" />
    <Button
      variant="outline"
      size="sm"
      onClick={onExportCsv}
      disabled={exporting}
      data-testid="export-csv-btn"
    >
      <FileCsv size={16} className="mr-1" />
      CSV
    </Button>
    <Button
      variant="outline"
      size="sm"
      onClick={onExportPdf}
      disabled={exporting}
      data-testid="export-pdf-btn"
    >
      <FilePdf size={16} className="mr-1" />
      PDF
    </Button>
  </div>
);

export default TrendsToolbar;
